document.addEventListener('DOMContentLoaded', function () {
	const linkSrb = document.getElementById('srb');
	const linkCg = document.getElementById('cg');
	const wrapper = document.getElementById('gde-kupiti');

	if (linkSrb) {
		linkSrb.addEventListener('click', function (e) {
			e.preventDefault();
			wrapper.classList.remove('show-cg');
			wrapper.classList.add('show-srb');
		});
	}

	if (linkCg) {
		linkCg.addEventListener('click', function (e) {
			e.preventDefault();
			wrapper.classList.remove('show-srb');
			wrapper.classList.add('show-cg');
		});
	}
});